<mat-form-field appearance="outline" #timeFormField
                [class]="appClass"
                [ngClass]="{'no-hint': !hint && (valid || !error), 'field-error': !valid, 'no-label': !label && !withPrefix,
                            'dynamic-width': dynamicWidth, 'with-prefix': withPrefix, 'with-suffix': withSuffix}">
  <mat-label *ngIf="label">{{ label | translate }}</mat-label>
  <input matInput type="time" #timeInput [(ngModel)]="time" [ngModelOptions]="{standalone: true}" [disabled]="disabled" (focusin)="manualTime = true">
  <mat-icon matTextSuffix class="svg-icon" [svgIcon]="'time'"></mat-icon>
  <mat-hint *ngIf="hint || (!valid && error)" [ngClass]="{'text-warning': !valid}">
    <mat-icon class="svg-icon" [svgIcon]="'warning'"></mat-icon>
    {{ ((!valid && error) ? error : hint) | translate }}
  </mat-hint>
</mat-form-field>
